<prlw-text-tag *ngIf="isOtp()" [size]="size" text="отп"></prlw-text-tag>
